.container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-evenly;
}
